import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { AiFillDelete } from "react-icons/ai";





function Cards(props) {

    const { _id, Total_Payment, Shope_Name, Owener_Name, Worker_Name, Vehical_Name, Vehical_Model, Working_in_Vehicle, Labour_Charge, Payment, Dues_Payment, Date, UpDated_Time, UpDated_Date } = props.data

    const [updatepayment, setupdatepayment] = useState('')
    const [token,settoken]=useState('')
    const [user,setUser]=useState('')


    useEffect(()=>{
        settoken(localStorage.getItem('token'))
        setUser(localStorage.getItem('useuserId'))
      },[])

    const navigate = useNavigate()



    const handleAPI = async (id) => {

        console.log(id)

        await axios.put('https://tinkus.onrender.com/update', {

       
            id: id,
            Payment: updatepayment,
            'UserId': user,
            'token': token
        })
            .then((result) => {
                console.log(result)
                setupdatepayment('')
                alert("Update Payment SuccessFully")
                navigate('/')

            })
            .catch((err) => {
                console.log(err)
                alert(err.response.data.msg)

            })

    }




   


    console.log(token,user)




 const handleDelete= async(id)=>{

    await axios.delete('https://tinkus.onrender.com/deletePost', {
            headers: {
                'UserId': id,
                'token': token
            }
        })

            .then((result) => {
                console.log(result.data.data)
                alert('Post Delete SuccesFully')
                navigate('/')

            })
            .catch((err) => {
                console.log(err)

                alert(err.response.data.msg)
            })










  }



















    return (
        <div >

            <div className='d-flex'>

                <div id='a' className=" m-3 p-1 bg-dark " style={{ width: "22rem" }}>
                    <div className="card-body">
                       <div>
                       <h2 id='hed' className="card-title">{Shope_Name} <Link onClick={()=>handleDelete(_id)}><span id='del'><AiFillDelete/></span></Link> </h2>
                        
                       </div>
                       
                        <hr />
                        
                        <h5 >Shope_Ower_Name : <span>{Owener_Name} </span> </h5>
                        <h5 >Name : <span>{Worker_Name} </span> </h5>
                        <h5 >Vehicle_Name : <span>{Vehical_Name} </span> </h5>
                        <h5 >Vehicle_Model : <span>{Vehical_Model} </span></h5>
                        <p >Working in Vehicle : <span>{Working_in_Vehicle} </span></p>
                        <h5>Labour_Charge : <span>₹ {Labour_Charge} </span></h5>
                        <h5 >Total_Payment : <span>₹ {Total_Payment} </span></h5>
                        <h5 >Last_Payment : <span>₹ {Payment} </span></h5>
                        <p>Start Date of Working : <span>{Date}</span></p>
                        <p>Last_Payment On: <span>{UpDated_Date}</span> Time: <span>{UpDated_Time}</span></p>
                        <h2>Dues Amount :  <span id='due'>₹ {Dues_Payment} </span> </h2>
                        <Link id='li' onClick={() => handleAPI(_id)} className="card-link">Payment</Link>
                        <input onChange={(e) => setupdatepayment(e.target.value)} id='cc' type='text'></input>

                    </div>
                </div>




            </div>





        </div>

    )
}

export default Cards
